const Style = {

  link: 'block text-sg-blue hover:text-sg-blue-ink underline mb-4'

} 

export default Style;